(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    (function() {
    /* ===== AUTO-CLOSE (mobile + desktop native) ===== */
    document.addEventListener('toggle', function(e) {
      var details = e.target;
      if (!details.matches || !details.matches('.details')) return;
      if (!details.open) return;

      var group = details.closest('[data-accordion-group]');
      if (!group) return;
      if (group.dataset.autoClose !== 'true') return;

      var allDetails = group.querySelectorAll('.details[open]');
      allDetails.forEach(function(d) {
        if (d !== details) d.removeAttribute('open');
      });
    }, true);

    /* ===== DESKTOP FULL-COLUMN OVERLAY ===== */
    function initDesktopOverlay() {
      var groups = document.querySelectorAll('[data-accordion-group][data-desktop-overlay="true"]');

      groups.forEach(function(group) {
        if (group._overlayV2) return;
        group._overlayV2 = true;

        /* ---- Find parent container ---- */
        var selectorRaw = group.dataset.overlayContainer || '';
        var parentContainer = null;

        if (selectorRaw.trim()) {
          parentContainer = group.closest(selectorRaw.trim()) || document.querySelector(selectorRaw.trim());
        }

        if (!parentContainer) {
          parentContainer = findOverlayParent(group);
        }

        if (!parentContainer) {
          parentContainer = group.parentElement;
        }

        /* Ensure positioning context */
        parentContainer.classList.add('accordion-overlay-parent');

        /* Make parent stretch to full column height so accordion pushes to bottom */
        if (window.innerWidth >= 750) {
          ensureParentStretches(parentContainer);
        }

        /* ---- Build overlay DOM ---- */
        var panel = document.createElement('div');
        panel.className = 'accordion-overlay-panel';

        /* Copy CSS custom properties from accordion to panel */
        var groupStyles = getComputedStyle(group);
        ['--desktop-overlay-bg', '--desktop-overlay-text', '--desktop-overlay-border-color'].forEach(function(prop) {
          var val = groupStyles.getPropertyValue(prop);
          if (val) panel.style.setProperty(prop, val.trim());
        });
        /* Also copy font properties for overlay title */
        ['--summary-font-family', '--summary-font-style', '--summary-font-weight', '--summary-font-size', '--summary-font-line-height', '--summary-font-case'].forEach(function(prop) {
          var val = groupStyles.getPropertyValue(prop);
          if (val) panel.style.setProperty(prop, val.trim());
        });

        panel.innerHTML =
          '<div class="accordion-overlay-panel__header">' +
            '<div class="accordion-overlay-panel__title"></div>' +
            '<button class="accordion-overlay-panel__close" aria-label="Close">' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<line x1="18" y1="6" x2="6" y2="18"></line>' +
                '<line x1="6" y1="6" x2="18" y2="18"></line>' +
              '</svg>' +
            '</button>' +
          '</div>' +
          '<div class="accordion-overlay-panel__body"></div>';

        parentContainer.appendChild(panel);

        var panelTitle = panel.querySelector('.accordion-overlay-panel__title');
        var panelBody = panel.querySelector('.accordion-overlay-panel__body');
        var closeBtn = panel.querySelector('.accordion-overlay-panel__close');

        function isMobile() {
          return window.innerWidth < 750;
        }

        /* ---- Position overlay: cover parent but stop above accordion buttons ---- */
        function positionOverlay() {
          if (!panel.classList.contains('is-active')) return;

          var parentRect = parentContainer.getBoundingClientRect();
          var accordionRect = group.getBoundingClientRect();

          /* Distance from parent top to accordion top = overlay height */
          var bottomOffset = parentRect.bottom - accordionRect.top;
          if (bottomOffset < 0) bottomOffset = 0;

          panel.style.bottom = bottomOffset + 'px';
        }

        /* ---- Setup accordion items ---- */
        var items = group.querySelectorAll('accordion-custom');

        items.forEach(function(item) {
          var summary = item.querySelector('.details__header');
          if (!summary) return;

          /* Inject CSS +/- icon */
          if (!summary.querySelector('.desktop-icon-toggle')) {
            var icon = document.createElement('span');
            icon.className = 'desktop-icon-toggle';
            summary.insertBefore(icon, summary.firstChild);
          }

          summary.addEventListener('click', function(e) {
            if (isMobile()) return;
            e.preventDefault();
            e.stopPropagation();

            var wasActive = item.classList.contains('is-overlay-active');
            doClose(panel, items);

            if (!wasActive) {
              doOpen(item, panel, panelTitle, panelBody);
              positionOverlay();
            }
          });
        });

        closeBtn.addEventListener('click', function() {
          doClose(panel, items);
        });

        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && panel.classList.contains('is-active')) {
            doClose(panel, items);
          }
        });

        var resizeTimer;
        window.addEventListener('resize', function() {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function() {
            if (isMobile() && panel.classList.contains('is-active')) {
              doClose(panel, items);
            }
            positionOverlay();
          }, 100);
        });

        /* Prevent native <details> from toggling on desktop */
        group.querySelectorAll('.details').forEach(function(d) {
          d.addEventListener('toggle', function() {
            if (!isMobile() && d.open) d.removeAttribute('open');
          });
        });
      });
    }

    /* ---- Ensure parent stretches to full column height ---- */
    function ensureParentStretches(parent) {
      if (!parent || !parent.parentElement) return;

      var grandparent = parent.parentElement;

      /* Force grandparent to stretch its children equally */
      var gpStyle = getComputedStyle(grandparent);
      var gpDisplay = gpStyle.display;

      if (gpDisplay === 'grid' || gpDisplay === 'inline-grid') {
        grandparent.style.alignItems = 'stretch';
      } else if (gpDisplay === 'flex' || gpDisplay === 'inline-flex') {
        grandparent.style.alignItems = 'stretch';
      }

      parent.style.alignSelf = 'stretch';

      /* Fallback: directly measure the tallest sibling and set min-height */
      function matchHeight() {
        var siblings = grandparent.children;
        var maxH = 0;

        for (var i = 0; i < siblings.length; i++) {
          if (siblings[i] !== parent) {
            var h = siblings[i].getBoundingClientRect().height;
            if (h > maxH) maxH = h;
          }
        }

        if (maxH > parent.offsetHeight + 20) {
          parent.style.minHeight = maxH + 'px';
        }
      }

      /* Run after layout settles */
      requestAnimationFrame(function() {
        requestAnimationFrame(matchHeight);
      });

      /* Also re-match on window load (images may change heights) */
      window.addEventListener('load', matchHeight);
    }

    /* ---- Auto-detect the product info column ---- */
    function findOverlayParent(accordion) {
      var el = accordion.parentElement;

      /* First pass: look for known column/product-info classes */
      var current = el;
      while (current && current !== document.body) {
        var cls = current.className || '';
        if (
          cls.indexOf('layout-panel-flex--column') > -1 ||
          cls.indexOf('product__info') > -1 ||
          cls.indexOf('product-info') > -1 ||
          cls.indexOf('product__column') > -1 ||
          cls.indexOf('product-column') > -1 ||
          cls.indexOf('product-form__info') > -1
        ) {
          return current;
        }
        current = current.parentElement;
      }

      /* Second pass: find a container significantly taller than accordion */
      var accH = accordion.offsetHeight;
      current = el;
      while (current && current !== document.body) {
        if (current.offsetHeight > accH * 2.5 && current.offsetHeight > 300) {
          return current;
        }
        current = current.parentElement;
      }

      /* Fallback: 3 levels up */
      current = el;
      for (var i = 0; i < 2 && current && current.parentElement; i++) {
        current = current.parentElement;
      }
      return current;
    }

    /* ---- Open ---- */
    function doOpen(item, panel, panelTitle, panelBody) {
      var summary = item.querySelector('.details__header');
      var content = item.querySelector('.details-content');
      if (!summary || !content) return;

      /* Extract clean heading text */
      var text = '';
      summary.childNodes.forEach(function(n) {
        if (n.nodeType === 3) {
          text += n.textContent;
        } else if (n.nodeType === 1 &&
          !n.classList.contains('svg-wrapper') &&
          !n.classList.contains('icon-caret') &&
          !n.classList.contains('icon-plus') &&
          !n.classList.contains('desktop-icon-toggle') &&
          !n.classList.contains('details__icon')) {
          text += n.textContent;
        }
      });
      panelTitle.textContent = text.trim();

      /* Clone content */
      panelBody.innerHTML = '';
      var clone = content.cloneNode(true);
      clone.classList.remove('details-content');
      clone.classList.add('accordion-overlay-cloned-content');
      panelBody.appendChild(clone);

      item.classList.add('is-overlay-active');
      panel.classList.add('is-active');
      panelBody.scrollTop = 0;
    }

    /* ---- Close ---- */
    function doClose(panel, items) {
      panel.classList.remove('is-active');
      items.forEach(function(item) {
        item.classList.remove('is-overlay-active');
      });
    }

    /* ---- Init ---- */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDesktopOverlay);
    } else {
      initDesktopOverlay();
    }

    document.addEventListener('shopify:section:load', function() {
      document.querySelectorAll('[data-accordion-group]').forEach(function(g) {
        g._overlayV2 = false;
      });
      initDesktopOverlay();
    });
    document.addEventListener('shopify:block:select', initDesktopOverlay);
  })();
  } catch(e) { console.error(e); }
})();

})();
